import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//import useStyles from '../style';
import { lmtdCheck, getJCJPIDs } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { activationDistCsvFilter } from "../../../../../utils/common/csvMappings/activationDistributionCsv";
import ActivationSalesDistributionTabsView from "../../../../../views/activationSales/components/distribution/activationSalesDistributionTabsView";
import PropTypes from "prop-types";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";

const ActivationSalesDistributionTabs = (props) => {
  const dispatch = useDispatch();

  let {
    url,
    csvEndPointUrl,
    isCsvActive,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchActivationDistributionTable,
    triggerActivationDistributionCsv,
    section,
    moduleName,
  } = props;

  let { level, jioPointId, partnerRT, id } = getJCJPIDs(filterValue);
  const data = {
    id: id,
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: "DISTRIBUTION", //props.section
    moduleName: "ACTIVATION", //props.moduleName
    level: level,
    jioPointId: jioPointId,
  };

  const { distributionObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  useEffect(() => {
    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: data,
        extraData: url,
      };

      return dispatch(triggerFetchActivationDistributionTable(obj));
    }
    if (
      distributionObj &&
      distributionObj.distributionTableData[url] === undefined
    ) {
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchActivationDistributionTable,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  function fetchCsvData(tab) {
    let dist;
    if (tab === "Billed") {
      dist = "billed";
    } else {
      dist = "onboard";
    }
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        id: id, //filterValue.agentId ? filterValue.orgId : filterValue.selectedRole.split(" - ")[2],
        partnerRoleType: partnerRT,
        fromDate: headerSelectedDateFrom,
        toDate: headerSelectedDateTo,
        section: "DISTRIBUTION",
        moduleName: "ACTIVATION",
        dist: dist,
        level: level,
        jioPointId: jioPointId,
      },
      extraData: csvEndPointUrl,
      tab: tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "ActivationDistribution",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerActivationDistributionCsv(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = activationDistCsvFilter(
            props.filterValue.selectedJC === ""
              ? props.filterValue.selectedPartnerRoleName
              : props.filterValue.selectedJC === "ALL"
              ? props.filterValue.selectedPartnerRoleName
              : "JP",
            lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
              ? "YES"
              : "NO",
            params.dist,
            response.content
          );
          // let csvData;
          // if (params.dist === 'billed') {
          //     csvData = billedFilter(response.content, 'ACTIVATION')
          // }
          // else {
          //     csvData = onBoardedFilter(response.content, 'ACTIVATION')
          // }
          csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  return (
    <ActivationSalesDistributionTabsView
      url={url}
      csvEndPointUrl={csvEndPointUrl}
      isCsvActive={isCsvActive}
      filterValue={filterValue}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      fetchCsvData={fetchCsvData}
      section={section}
      moduleName={moduleName}
    />
  );
};

ActivationSalesDistributionTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};

export default ActivationSalesDistributionTabs;
